import * as jsPDF from 'jspdf';

const getTextWidth = (doc, text) =>
    doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;

const fitSize = (doc, text, maxPx, maxSize, minSize = 10) => {
    let size = maxSize;
    doc.setFontSize(size);
    while (size > minSize && getTextWidth(doc, text) > maxPx) {
        size -= 1;
        doc.setFontSize(size);
    }
    return size;
};

const drawLabel = (doc, data) => {
    const w = doc.internal.pageSize.getWidth();
    const h = doc.internal.pageSize.getHeight();
    const cx     = w / 2;
    const xL     = w * 0.08;
    const xR     = w * 0.92;
    const maxHalf = w * 0.40;
    const maxW    = w * 0.84;

    const tLeft   = (text, y, size, style = 'normal') => {
        doc.setFontSize(size); doc.setFontStyle(style);
        doc.text(text || '', xL, y, { align: 'left' });
    };
    const tRight  = (text, y, size, style = 'normal') => {
        doc.setFontSize(size); doc.setFontStyle(style);
        doc.text(text || '', xR, y, { align: 'right' });
    };
    const tCenter = (text, y, size, style = 'normal', opts = {}) => {
        doc.setFontSize(size); doc.setFontStyle(style);
        doc.text(text || '', cx, y, { align: 'center', ...opts });
    };

    // Fila superior: Referencia (izq) | Modelo (dcha)
    const refSize    = fitSize(doc, data.reference || '', maxHalf, 34);
    tLeft(data.reference || '', h * 0.14, refSize, 'bold');

    const modeloSize = fitSize(doc, data.modelo || '', maxHalf, 56, 24);
    tRight(data.modelo || '', h * 0.14, modeloSize, 'bold');

    // Separador
    doc.setDrawColor(180); doc.setLineWidth(0.5);
    doc.line(xL, h * 0.19, xR, h * 0.19);

    // GB · Salud
    const line1 = [
        data.capacidad || '',
        data.salud != null ? `${data.salud}%` : '',
    ].filter(Boolean).join('  ·  ');
    const line1Size = fitSize(doc, line1, maxW, 30);
    tCenter(line1, h * 0.31, line1Size);

    // Color · Condición
    const line2 = [
        data.color || '',
        data.condicion ? (data.condicion === 'premium' ? 'Premium' : 'Usado') : '',
    ].filter(Boolean).join('  ·  ');
    const line2Size = fitSize(doc, line2, maxW, 30);
    tCenter(line2, h * 0.43, line2Size);

    // IMEI
    if (data.imei) {
        const imeiText = `IMEI: ${data.imei}`;
        const imeiSize = fitSize(doc, imeiText, maxW, 26);
        tCenter(imeiText, h * 0.54, imeiSize);
    }

    // Precio
    if (data.precio != null) {
        const precioText = `${data.precio} €`;
        const precioSize = fitSize(doc, precioText, maxW, 62);
        tCenter(precioText, h * 0.74, precioSize, 'bold');
    }

    // Observaciones
    if (data.observaciones1) tCenter(data.observaciones1, h * 0.85, 21, 'normal', { maxWidth: maxW });
    if (data.observaciones2) tCenter(data.observaciones2, h * 0.93, 21, 'normal', { maxWidth: maxW });
};

export const printReacLabel = (items) => {
    const list = Array.isArray(items) ? items : [items];
    const doc = new jsPDF('l', 'mm', [420, 290]);

    list.forEach((data, i) => {
        if (i > 0) doc.addPage();
        drawLabel(doc, data);
    });

    doc.autoPrint();
    doc.output('dataurlnewwindow');
};
